<template>
  <div class="transition">
    <div v-if="estMessageAdherent" class="transition-items">
      <BasicText>
        Pour déposer un avenant à l'un de vos contrats, merci de bien vouloir rechercher votre contrat d'apprentissage
        depuis le menu dossiers pour déposer le document d'avenant ou en cliquant sur le lien ci-dessous
      </BasicText>

      <BasicLink
        label="Rechercher le contrat d'apprentissage"
        @link-click="navigateToRechercheDossierCAPP"
      />
    </div>
    <div v-else class="transition-items">
      <BasicText>
        Hors mandat de gestion, l'avenant doit être déposé par
        l'employeur sur son espace, sur le dossier initial concerné.
      </BasicText>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { RechercheQueryDTO } from '@/features/api/extranet/dto/Dossier/Recherche'
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import { injectLoadRechercheService } from '@/features/interface/recherches/rechercheRoutingServiceProvider'
  import type { PagedRequest } from '@/features/interface/recherches/storeRechercheBuilder'
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
  import type { TransitionCapAvenantSelectionnéIn } from '../CreationDemandeConfiguration.types.ts'
  import { computed } from 'vue'

  const props = defineProps<CarteProps<TransitionCapAvenantSelectionnéIn, void>>()
  const emits = defineEmits<CarteEvents<void>>()

  const estMessageAdherent = computed(() =>
    props.in.context === TypesContextesAutorisesEnum.Adherent || props.in.sousMandatGestion
  )

  const { loadPageWithPagedRequest } = injectLoadRechercheService('dossier')

  function navigateToRechercheDossierCAPP() {
    loadPageWithPagedRequest({
      query: {
        dispositifs: ['CAPP'],
        statuts: [
          'EnCoursAnalyse',
          'AttentePiecesInstruction',
          'Cloture',
          'Accorde',
          'Rupture',
          'Transmis',
          'AttentePiecesReglement',
          'TransfereAOpcoMobilite',
          'TransfereAOpco2I',
          'TransfereAOpcommerce',
          'TransfereAOpcoAtlas',
        ],
      },
      route: { name: 'recherche-dossier' },
    } as PagedRequest<RechercheQueryDTO>)
    emits('queryCancel')
  }
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';
  .transition-items {
    max-width: 600px;
  }
</style>
